import { render, staticRenderFns } from "./IDateTime.vue?vue&type=template&id=35ad6442&scoped=true&"
import script from "./IDateTime.vue?vue&type=script&lang=ts&"
export * from "./IDateTime.vue?vue&type=script&lang=ts&"
import style0 from "./IDateTime.vue?vue&type=style&index=0&id=35ad6442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad6442",
  null
  
)

export default component.exports